<template>
  <CardContainer :cardTitle="title" :isEmptyData="isLoaded && dataSource != null && dataSource.dataset.length === 0" :titleId="'horizontal-' + index" :participantName="dataParticipantName" :primaryColor="primaryColor" :choosenAnswers="choosenAnswers">
    <b-row slot="body">
      <b-colxx md="10" class="p-0">
        <fusioncharts type="scrollbar2d" width="100%" height="350" dataFormat="json" :dataSource="dataSource" :events="fcEvents"> </fusioncharts>
      </b-colxx>
      <ChartLegend :participantName="dataParticipantName" :primaryColor="primaryColor"></ChartLegend>
    </b-row>
  </CardContainer>
</template>
<script>
import _ from "lodash";
import CardContainer from "./card-container";
import { generateHorizontalBarChart, shadeColor } from "../../services/utils";
import { optionHorizontalBarChart } from "../../services/chart-config";
import ChartLegend from "./chart-legend-card";

export default {
  props: {
    index: [String, Number],
    title: { type: String, default: "Default Title" },
    isLoaded: { type: Boolean, default: false },
    dataSources: [Array, null],
    primaryColor: { type: String, default: "" },
    dataParticipantName: { type: String, default: "" }
  },
  components: {
    CardContainer,
    ChartLegend
  },
  data() {
    return {
      dataSource: null,
      colorLegendOthers: shadeColor(this.primaryColor, 30),
      fcEvents: {
        dataPlotRollOver: () => {
          this.dataSource.chart.toolTipBgAlpha = "0";
        },
        dataLabelRollOver: () => {
          this.dataSource.chart.toolTipBgAlpha = "100";
        }
      },
      choosenAnswers: []
    };
  },
  methods: {
    processVisualization() {
      const clonedOptions = _.cloneDeep(optionHorizontalBarChart);
      const { categories, datasets, choosenAnswers } = generateHorizontalBarChart(this.dataSources, this.primaryColor);
      this.choosenAnswers = choosenAnswers;
      if (datasets.length > 0) {
        clonedOptions.categories.push({ category: categories });
        clonedOptions.dataset.push({ data: datasets });
      }
      this.dataSource = clonedOptions;
    }
  },
  mounted() {
    this.processVisualization();
  }
};
</script>
